/* Stylesheets */
import "./scss/vendors/bootstrap.scss"; // ref: https://getbootstrap.com/docs/5.3/customize/sass/#importing
// import './scss/vendors/swiper.scss'; // ref: https://swiperjs.com/get-started#installation
import "./scss/vendors/hamburgers.scss"; // ref: https://jonsuh.com/hamburgers/#sass
// import './scss/fonts.scss';
// import './scss/vendors/energy-saver.scss';
// import './scss/vendors/wheel-of-fortune.scss';
import "./scss/style.scss";

import TomSelect from 'tom-select'; // ref: https://tom-select.js.org/

/* Scripts */
import { Offcanvas } from "bootstrap"; // ref: https://getbootstrap.com/docs/5.3/getting-started/webpack/#import-bootstrap - Point 3.

// import Swiper from 'swiper'; // ref: https://swiperjs.com/get-started#install-from-npm
// import { } from 'swiper/modules';
// const swiperTranslations = {
//     firstSlideMessage: `Questa è la prima slide`,
//     lastSlideMessage: `Questa è l'ultima slide`,
//     nextSlideMessage: `Vai alla prossima slide`,
//     paginationBulletMessage: `Vai alla slide {{index}}`,
//     prevSlideMessage: `Vai alla slide precedente`,
//     slideLabelMessage: `{{index}} di {{slidesLength}}`
// } // Oggetto da passare alla proprietà a11y: { ...options, ...swiperTranslations } dell'istanza Swiper - ref: https://docs.google.com/presentation/d/1dhMLaonvwWgX0t-fAxPU4PubI_u6QTrl10IfM6Badng/edit?slide=id.g3a1f0c75b34_0_0#slide=id.g3a1f0c75b34_0_0

import { library, dom } from "@fortawesome/fontawesome-svg-core"; // ref: https://fontawesome.com/docs/apis/javascript/import-icons#package-names
// import { faFreeB } from '@fortawesome/free-brands-svg-icons';
// import { faFreeS } from '@fortawesome/free-solid-svg-icons';
// import { faFreeR } from '@fortawesome/free-regular-svg-icons';
// import { faProS } from '@fortawesome/pro-solid-svg-icons';
import { faCircleUser, faCircleUserCircleCheck } from "@fortawesome/pro-regular-svg-icons";
import { faTicketPerforated, faAddressCard, faBlockQuestion, faGiftCard, faPaperPlaneTop, faFish, faBarcodeRead, faArrowRight, faEye, faEyeSlash, faThumbsUp, faCartShopping, faReceipt, faCircleInfo, faFilePdf, faImage, faArrowLeft, faCheck, faFaceFrown } from "@fortawesome/pro-light-svg-icons";
// import { faProT } from '@fortawesome/pro-thin-svg-icons';
// import { faProD } from '@fortawesome/pro-duotone-svg-icons';
// import { faDuotoneR } from '@fortawesome/duotone-regular-svg-icons';
// import { faDuotoneL } from '@fortawesome/duotone-light-svg-icons';
// import { faDuotoneT } from '@fortawesome/duotone-thin-svg-icons';
// import { faSharpS } from '@fortawesome/sharp-solid-svg-icons';
// import { faSharpR } from '@fortawesome/sharp-regular-svg-icons';
// import { faSharpL } from '@fortawesome/sharp-light-svg-icons';
// import { faSharpT } from '@fortawesome/sharp-thin-svg-icons';
// import { faSharpD } from '@fortawesome/sharp-duotone-solid-svg-icons';
// import { faSharpDR } from '@fortawesome/sharp-duotone-regular-svg-icons';
// import { faSharpDL } from '@fortawesome/sharp-duotone-light-svg-icons';
// import { faSharpDT } from '@fortawesome/sharp-duotone-thin-svg-icons';
// import { faFree } from '@fortawesome/fontawesome-free';
// import { faPro } from '@fortawesome/fontawesome-pro';
library.add(faCircleUser, faCircleUserCircleCheck);
library.add(faTicketPerforated, faAddressCard, faBlockQuestion, faGiftCard, faPaperPlaneTop, faFish, faCircleUserCircleCheck, faBarcodeRead, faArrowRight, faEye, faEyeSlash, faThumbsUp, faCartShopping, faReceipt, faCircleInfo, faFilePdf, faImage, faArrowLeft, faCheck, faFaceFrown);
// library.add(faDuotoneR, faDuotoneL, faDuotoneT);
// library.add(faSharpS, faSharpR, faSharpL, faSharpT, faSharpD, faSharpDR, faSharpDL, faSharpDT);
// library.add(faFree, faPro);
dom.watch();

// import EnergySaver from './js/vendors/energy-saver';

import Cleave from "cleave.js";
require("cleave.js/dist/addons/cleave-phone.it");

import Handlebars from "handlebars";
import { WheelOfFortune } from "./js/vendors/wheel-of-fortune.js";
import { DEFAULT_SEGMENTS, ConfigUtils } from "./js/vendors/wheel-config.js";

/* Init Functions on DOMContentLoaded */
const ready = (callback) => {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
};

const isDebug = process.env.NODE_ENV !== "production";

/* Variables and functions */
const initWebpackVersion = () => {
    isDebug && console.log(`%c${DESCRIPTION}`, `color: #9ac456; font-size: 18px; font-weight: 700;`, `Version ${VERSION} - Development Environment`);
};

const goToAnchor = (el, offset = 0, behavior = "smooth") => {
    if (typeof el === "string") {
        el = document.querySelector(el);
    }

    if (el) {
        const y = el.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({
            top: y,
            behavior: behavior,
        });
    }
};

const showLoading = (el) => {
    el?.classList.add("disabled");

    const loadingLayer = document.querySelector(".loading-layer");
    if (loadingLayer) {
        loadingLayer.style.display = "block";
    }
};

const hideLoading = () => {
    const loadingButtons = [...document.querySelectorAll(".btn-loading")];
    loadingButtons.forEach((button) => {
        button.classList.remove("disabled");
    });

    const loadingLayer = document.querySelector(".loading-layer");
    if (loadingLayer) {
        loadingLayer.style.display = "none";
    }
};

const initCleave = () => {
    const Cap = document.getElementById("Input_Cap");
    if (Cap) {
        new Cleave(Cap, {
            blocks: [5],
            numericOnly: true,
        });
    }

    const TelefonoRaw = document.getElementById("Input_Telefono");
    if (TelefonoRaw) {
        new Cleave(TelefonoRaw, {
            phone: true,
            phoneRegionCode: "IT",
        });
    }

    const DataDiNascita = document.getElementById("Input_DataNascita");
    if (DataDiNascita) {
        new Cleave(DataDiNascita, {
            date: true,
            delimiter: "/",
            datePattern: ["d", "m", "Y"],
        });
    }

    const Input1_Data = document.getElementById("Input1_Data");
    if (Input1_Data) {
        new Cleave(Input1_Data, {
            date: true,
            delimiter: "/",
            datePattern: ["d", "m", "Y"],
        });
    }

    const Input2_Data = document.getElementById("Input2_Data");
    if (Input2_Data) {
        new Cleave(Input2_Data, {
            date: true,
            delimiter: "/",
            datePattern: ["d", "m", "Y"],
        });
    }

    const Input1_Ora = document.getElementById('Input1_Ora');
    if (Input1_Ora) {
        new Cleave(Input1_Ora, {
            time: true,
            timePattern: ['h', 'm']
        });
    }

    const Input1_Numero = document.getElementById('Input1_Numero');
    if (Input1_Numero) {
        new Cleave(Input1_Numero, {
            blocks: [8],
            numericOnly: true
        });
    }

    const Input1_Importo = document.getElementById('Input1_Importo');
    if (Input1_Importo) {
        new Cleave(Input1_Importo, {
            numeralDecimalMark: ',',
            numeralDecimalScale: 2,
            numeralThousandsGroupStyle: 'none',
            numeral: true
        });
    }

    const Input1_ImportoProd1 = document.getElementById('Input1_ImportoProd1');
    if (Input1_ImportoProd1) {
        new Cleave(Input1_ImportoProd1, {
            numeralDecimalMark: ',',
            numeralDecimalScale: 2,
            numeralThousandsGroupStyle: 'none',
            numeral: true
        });
    }

    const Input1_ImportoProd2 = document.getElementById('Input1_ImportoProd2');
    if (Input1_ImportoProd2) {
        new Cleave(Input1_ImportoProd2, {
            numeralDecimalMark: ',',
            numeralDecimalScale: 2,
            numeralThousandsGroupStyle: 'none',
            numeral: true
        });
    }

    const Input2_Importo = document.getElementById('Input2_Importo');
    if (Input2_Importo) {
        new Cleave(Input2_Importo, {
            numeralDecimalMark: ',',
            numeralDecimalScale: 2,
            numeralThousandsGroupStyle: 'none',
            numeral: true
        });
    }
};

const initShowPassword = () => {
    [...document.querySelectorAll(".show-pwd")].forEach((eye) => {
        // Imposta gli attributi iniziali di accessibilità
        eye.setAttribute("type", "button");
        eye.setAttribute("aria-label", "Mostra password");
        eye.setAttribute("aria-pressed", "false");

        eye.addEventListener("click", (e) => {
            e.preventDefault();

            const iconPasswordContainer = eye.closest(".input-group");
            const passwordInput = iconPasswordContainer?.parentNode.querySelector("input");
            if (!passwordInput) return;

            const isPassword = passwordInput.getAttribute("type") === "password";
            passwordInput.setAttribute("type", isPassword ? "text" : "password");

            // Aggiorna gli attributi di accessibilità
            eye.setAttribute("aria-label", isPassword ? "Clicca qui per nascondere la password" : "Clicca qui per mostrare la password");
            eye.setAttribute("aria-pressed", isPassword ? "true" : "false");

            // Rimuovi l'SVG esistente
            const oldSvg = eye.querySelector("svg");
            if (oldSvg) {
                oldSvg.remove();
            }

            // Crea un nuovo elemento <i> con la classe corretta
            const newIcon = document.createElement("i");
            newIcon.className = isPassword ? "fa-light fa-eye-slash fa-fw" : "fa-light fa-eye fa-fw";
            newIcon.setAttribute("aria-hidden", "true");
            eye.appendChild(newIcon);

            // Converti il nuovo <i> in SVG
            dom.i2svg({ node: eye });
        });
    });
};

const initFormValidation = () => {
    const forms = document.querySelectorAll(".needs-validation");
    if (forms) {
        Array.from(forms).forEach((form) => {
            let allInputs = form.querySelectorAll("input, select, textarea");
            allInputs.forEach(function (el) {
                el.addEventListener("change", function (event) {
                    if (el.checkValidity()) {
                        el.removeAttribute("aria-invalid");
                    } else {
                        el.setAttribute("aria-invalid", "true");
                    }
                });
            });

            form.addEventListener(
                "submit",
                (e) => {
                    form.classList.add("was-validated");

                    let validFields = form.querySelectorAll("*:valid");
                    let invalidFields = form.querySelectorAll("*:invalid");
                    validFields.forEach(function (validField) {
                        validField.removeAttribute("aria-invalid");
                    });
                    invalidFields.forEach(function (invalidField) {
                        invalidField.setAttribute("aria-invalid", "true");
                    });

                    if (!form.checkValidity()) {
                        e.preventDefault();
                        e.stopPropagation();
                        invalidFields[0].focus();
                    } else {
                        const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
                        showLoading(submitButton);
                    }
                },
                false
            );
        });
    }
};

const closeMenuByNav = () => {
    Array.from(document.querySelectorAll('.nav-item a'))
        .forEach((el) => el.addEventListener('click', (evt) => {
            //Verifica se il link è un ancora, chiudi offcanvas e solo dopo che è chiuso esegui lo scroll
            const href = el.getAttribute('href');
            if (href && href.startsWith('/#')) {
                const offcanvasElement = document.querySelector('#offcanvasNavbar');
                if (offcanvasElement) {
                    const offcanvasMenu = Offcanvas.getInstance(offcanvasElement);
                    if (offcanvasMenu) {
                        offcanvasMenu.hide();
                        offcanvasElement.addEventListener('hidden.bs.offcanvas', function () {
                            const anchor = href.substring(1); // Rimuovi il '/' dall'inizio
                            goToAnchor(anchor);
                        }, { once: true });
                    }
                }
            }
        })
        );
};

const initReceiptUpload = () => {
    // === TROVO I PARAMETRI DEL FORM ===
    const form = document.querySelector("form[data-prefix]");
    if (!form) return;
    const prefix = form.dataset.prefix;
    const userId = window.userID; // ATTENZIONE agli apici!
    const jsonDataEl = document.getElementById(`${prefix}_JsonData`);

    const ocr = document.getElementById(`${prefix}_OCR`);
    const hdFileFronte = document.getElementById(`${prefix}_Fronte`);
    const hdFileRetro = document.getElementById(`${prefix}_Retro`);

    // (accessibilità) focus sugli input file, per attivare il focus sul contenitore padre
    ["Input1_FileFronte", "Input1_FileRetro", "Input1_Prodotti_file", "Input2_FileFronte", "Input2_FileRetro", "Input2_Prodotti_file"].forEach(id => {
        const input = document.getElementById(id);
        const uploadCopy = input?.closest(".wrap-upload")?.querySelector(".upload-copy");
        if (input && uploadCopy) {
            input.addEventListener("focus", () => uploadCopy.classList.add("focused"));
            input.addEventListener("blur", () => uploadCopy.classList.remove("focused"));
        }
    });


    // === INPUT FILE E DIV ERROR ===
    const btnFronte = document.getElementById(`${prefix}_FileFronte`);
    const btnRetro = document.getElementById(`${prefix}_FileRetro`);
    const btnProdotti = document.getElementById(`${prefix}_Prodotti_file`);
    const errFronte = "uploadErrorFronte";
    const errRetro = "uploadErrorRetro";
    const errProdotti = "uploadErrorProdotti";

    // === helper: soddisfa/riattiva il required del file in base alla presenza dell'immagine ===
    function satisfyFileRequirement(prefix, tipo, satisfied) {
        const idMap = {
            fronte: `${prefix}_FileFronte`,
            retro: `${prefix}_FileRetro`,
            prodotti: `${prefix}_Prodotti_file`
        };
        const input = document.getElementById(idMap[tipo]);
        if (!input) return;

        if (satisfied) {
            input.removeAttribute("required");
            input.required = false;
            input.setCustomValidity(""); // pulisce stato invalid del browser (se c'era)
            input.classList.remove("is-invalid");
            const invalidId = input.getAttribute("aria-describedby");
            if (invalidId) {
                const inv = document.getElementById(invalidId);
                inv?.classList?.remove("d-block");
            }
        } else {
            // NB: qui applichiamo il required solo per fronte/prodotti (retro mai)
            if (tipo !== "retro") {
                input.setAttribute("required", "required");
                input.required = true;
            }
            input.setCustomValidity(""); // prevenire stati sporchi
        }
    }

    // === MOSTRA MESSAGGIO ERRORE ALL’UTENTE ===
    function showUserError(id) {
        const d = document.getElementById(id);
        if (!d) return;
        d.textContent =
            "Il file non è stato caricato correttamente. " +
            "Verifica formato e peso (max 5 MB; jpg, jpeg, png, pdf) e riprova. " +
            "Se persiste, riprova più tardi.";
        d.classList.remove("d-none");
    }

    // === FETCH CON GESTIONE 400 ===
    async function fetchData(fd, tipo, userId) {
        console.log('fetchData');
        const d = document.getElementById(userId);
        if (d) d.classList.add("d-none");
        try {
            const res = await fetch("/api/FileUpload/UploadReceipt", { method: "POST", body: fd });
            if (!res.ok) {
                if (res.status === 400) showUserError(userId);
                throw new Error(`HTTP ${res.status}`);
            }
            const data = await res.json();
            if (jsonDataEl)
                jsonDataEl.value = JSON.stringify(data);
            elabResponse(data, tipo);
        } catch (err) {
            console.error("Errore durante l'upload:", err);
        } finally {
            hideLoading?.();
        }
    }

    // === PREPARA E INVIA IL FORM DATA ===
    function onUploading(file, tipo, errId) {
        console.log('onUploading');
        console.log({ file });
        console.log({ userId });

        if (!file || !userId) return;

        const lblId = (tipo === "prodotti") ? "lblNomeFileProdotti"
            : (tipo === "retro") ? "lblNomeFileRetro"
                : "lblNomeFileFronte";
        const lbl = document.getElementById(lblId);
        lbl?.classList.add('opacity-50');

        const loaderId = (tipo === "prodotti") ? "loaderNomeFileProdotti"
            : (tipo === "retro") ? "loaderNomeFileRetro"
                : "loaderNomeFileFronte";
        const loader = document.getElementById(loaderId);
        showLoading(loader);

        const fd = new FormData();
        fd.append("file", file);
        fd.append("front_back", tipo.toUpperCase());
        fd.append("receipt_invoice", prefix === "Input1" ? "SCONTRINO" : "FATTURA");
        fd.append("uid", userId);
        if (jsonDataEl) {
            fd.append("jsondata", jsonDataEl.value || "");
        }
        fetchData(fd, tipo, errId);
    }

    // === ATTACH EVENTI AI CAMPI FILE ===
    btnFronte?.addEventListener("change", e => {
        // se l'utente cambia immagine, torna required finché non c'è un valore valido
        satisfyFileRequirement(prefix, "fronte", false);
        onUploading(e.target.files[0], "fronte", errFronte);
    });

    btnRetro?.addEventListener("change", e => {
        // RETRO OPZIONALE: non impostiamo mai required sul retro
        onUploading(e.target.files[0], "retro", errRetro);
    });

    btnProdotti?.addEventListener("change", e => {
        satisfyFileRequirement(prefix, "prodotti", false);
        onUploading(e.target.files[0], "prodotti", errProdotti);
    });

    // === RICARICO LE PREVIEW SE TORNO INDIETRO / POSTBACK CON ERRORI ===
    loadImageOnPostback();

    // === PRIMA DI INVIARE IL FORM: il required deve riflettere i campi hidden ===
    form.addEventListener("submit", () => {
        // imponi required SOLO a fronte e prodotti
        ["fronte", "prodotti"].forEach(tipo => {
            const hid = (tipo === "prodotti")
                ? `${prefix}_Prodotti_hidden`
                : `${prefix}_${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`;
            const hasValue = !!document.getElementById(hid)?.value;
            satisfyFileRequirement(prefix, tipo, hasValue);
        });
        // per il retro, non facciamo nulla: resta opzionale
    });

    // ===============================
    // === FUNZIONI DI SUPPORTO ====
    // ===============================
    function elabResponse(res, tipo) {
        //chooseImage(res.immagini, tipo);
        writeImage(res.imageurl, tipo);
        // Se vuoi auto-precompilare dal tuo OCR:
        //if (tipo !== "prodotti" && res.datiOCR) prefillOcrData(res.datiOCR);
        if (ocr) {
            ocr.value = JSON.stringify(res);
        }
        if ("fronte" === tipo) {
            if (hdFileFronte) {
                hdFileFronte.value = res.guid;
            }
            prefillDataOCR(res);
        }
        if ("retro" === tipo) {
            if (hdFileRetro) {
                hdFileRetro.value = res.guid;
            }
        }
    }

    const parseIsoLocalParts = (iso) => {
        // Supporta: YYYY-MM-DDTHH:mm[:ss[.ms]][Z|+hh:mm|-hh:mm] (timezone ignorata)
        const m = iso.match(
            /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d+))?)?(?:Z|[+-]\d{2}:\d{2})?$/
        );
        if (!m) throw new Error("Formato data/ora non valido: " + iso);

        const [, yyyy, MM, dd, HH, mm, ss = "00"] = m;
        return { yyyy, MM, dd, HH, mm, ss };
    }

    const applyFormat = (parts, format) => {
        // Token supportati: yyyy, MM, dd, HH, mm, ss
        return format.replace(/yyyy|MM|dd|HH|mm|ss/g, token => parts[token]);
    }

    const doubleToCommaText = (value, decimals = null) => {
        const n = Number(value);
        if (!Number.isFinite(n)) return "";

        const s = decimals == null ? String(n) : n.toFixed(decimals);
        return s.replace(".", ",");
    }

    const formatIsoTime = (isoString, format = "HH:mm") => {
        const parts = parseIsoLocalParts(isoString);
        return applyFormat(parts, format);
    }

    function prefillDataOCR(data) {
        const dataAcquisto = document.getElementById(`${prefix}_Data`);
        const oraAcquisto = document.getElementById(`${prefix}_Ora`);
        const numeroEmissione = document.getElementById(`${prefix}_Numero`);
        const importoTotale = document.getElementById(`${prefix}_Importo`);
        const puntoVendita = document.getElementById(`${prefix}_PuntoVendita`);

        if (dataAcquisto && data.transactionDate)
            dataAcquisto.value = formatIsoTime(data.transactionDate, 'dd/MM/yyyy');
        if (oraAcquisto && data.transactionDate)
            oraAcquisto.value = formatIsoTime(data.transactionDate, 'HH:mm');
        if (numeroEmissione && data.reference)
            numeroEmissione.value = data.reference;
        if (importoTotale && data.transactionTotal)
            importoTotale.value = doubleToCommaText(data.transactionTotal, 2);
        if (puntoVendita && data.merchantName)
            puntoVendita.value = data.merchantName;
    }

    //function chooseImage(arr, tipo) {
    //    const map = { fronte: 1, retro: 2, prodotti: 3 };
    //    const imgObj = arr?.find(i => i.tipo === map[tipo])?.immagine;
    //    if (!imgObj) {
    //        console.warn(`Immagine tipo ${tipo} non trovata`);
    //        return;
    //    }
    //    // aggiorno il campo hidden
    //    const hid = (tipo === "prodotti")
    //        ? `${prefix}_Prodotti_hidden`
    //        : `${prefix}_${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`;
    //    const hidEl = document.getElementById(hid);
    //    if (hidEl) hidEl.value = JSON.stringify(imgObj);

    //    writeImage(imgObj, tipo);
    //}

    function writeImage(img, tipo) {
        const s3 = img;
        if (!s3) return;
        const isPdf = /\.pdf$/i.test(s3);
        const lblId = (tipo === "prodotti") ? "lblNomeFileProdotti"
            : (tipo === "retro") ? "lblNomeFileRetro"
                : "lblNomeFileFronte";
        const btnId = (tipo === "prodotti") ? `${prefix}_Prodotti_file`
            : (tipo === "retro") ? `${prefix}_FileRetro`
                : `${prefix}_FileFronte`;

        const uplWp = (tipo === "prodotti") ? `.wrap-upload_Prodotti_file`
            : (tipo === "retro") ? `.wrap-upload_FileRetro`
                : `.wrap-upload_FileFronte`;

        const lbl = document.getElementById(lblId);
        const btn = document.getElementById(btnId);
        const wrapUpload = document.querySelector(uplWp);

        //console.log(uplWp)
        lbl?.classList.remove('opacity-50');

        if (!lbl || !btn) return;

        lbl.innerHTML = "";
        //btn.classList.add("d-none");
        lbl.classList.remove("d-none");

        if (wrapUpload) wrapUpload.classList.add("opacity-25");

        const a = document.createElement("a");
        a.href = s3;
        a.target = "_blank";
        a.classList.add("preview", "me-3");
        a.setAttribute("aria-label", "Anteprima");

        const label = document.createElement("p");
        label.classList.add('fw-bold', 'text-uppercase', 'mb-1');
        label.innerHTML = tipo;

        if (isPdf) {
            //a.textContent = typeof svgIcoPDF !== "undefined" ? svgIcoPDF : "PDF";
            const icon = document.createElement('i');
            icon.classList.add('fa-light', 'fa-file-pdf', 'fa-3x');
            a.appendChild(icon);
        } else {
            const im = document.createElement("img");
            im.src = s3;
            im.alt = "";
            //im.classList.add("object-fit-cover");
            //im.style.maxWidth = "250px";
            //im.style.maxHeight = "250px";
            a.appendChild(im);
        }

        const nome = document.createElement('div');
        nome.classList.add('form-text', 'mt-2');
        nome.innerHTML = img?.nomeOriginale ?? '';


        console.log({ img });

        //const br = document.createElement("br");
        //const chg = document.createElement("a");
        //chg.href = "javascript:;";
        //chg.textContent = `Cambia immagine ${tipo}`;
        //chg.classList.add("btn", "btn-cambia-upload", "btn-blue", "btn-sm", "fs-x-small", "d-inline-block");
        //chg.onclick = () => {
        //    // riattivo il required SOLO per i campi che lo prevedono
        //    if (tipo !== "retro") satisfyFileRequirement(prefix, tipo, false);
        //    document.getElementById(btnId).click();
        //};

        lbl.append(label, a, nome);

        // immagine presente: rimuovi eventuale required/invalid
        satisfyFileRequirement(prefix, tipo, true);
    }

    async function loadImageOnPostback() {
        //["fronte", "retro", "prodotti"].forEach(tipo => {
        //    const hid = (tipo === "prodotti")
        //        ? `${prefix}_Prodotti_hidden`
        //        : `${prefix}_${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`;
        //    const v = document.getElementById(hid)?.value;
        //    if (v) {
        //        // ridisegno la preview e soddisfo i required relativi
        //        //writeImage(JSON.parse(v), tipo);

        //        satisfyFileRequirement(prefix, tipo, true);
        //    }
        //});
        if (hdFileFronte && hdFileFronte.value) {
            const guid = hdFileFronte.value;    //guid dell'immagine
            const imageUrlEndpoint = imageUrl; // handler AJAX
            const resp = await fetch(`${imageUrlEndpoint}&guid=${encodeURIComponent(guid)}`, {
                credentials: 'same-origin'
            });
            if (!resp.ok) {
                console.error('Errore HTTP nel recupero immagine salvata', resp.status);
            } else {
                const data = await resp.json();
                if (data && data.img) {
                    //renderImagePreview(previewFronte, data.img, inputFileFronte);
                    writeImage(data.img, 'fronte');
                } else {
                    console.warn('Risposta handler Image senza proprietà img', data);
                }
            }
        }

        if (hdFileRetro && hdFileRetro.value) {
            const guid = hdFileRetro.value;    //guid dell'immagine
            const imageUrlEndpoint = imageUrl; // handler AJAX
            const resp = await fetch(`${imageUrlEndpoint}&guid=${encodeURIComponent(guid)}`, {
                credentials: 'same-origin'
            });
            if (!resp.ok) {
                console.error('Errore HTTP nel recupero immagine salvata', resp.status);
            } else {
                const data = await resp.json();
                if (data && data.img) {
                    writeImage(data.img, 'retro');
                } else {
                    console.warn('Risposta handler Image senza proprietà img', data);
                }
            }
            hideLoading();
        }
    }

    function fmtDate(i) {
        const d = new Date(i); if (isNaN(d)) return "";
        return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
    }
    function fmtTime(i) {
        const d = new Date(i); if (isNaN(d)) return "";
        return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
    }
    function fmtPrice(v) {
        const n = Number(v); if (isNaN(n)) return "";
        return n.toFixed(2).replace(".", ",");
    }
}

function goBack() {
    document.getElementById("inputIndietro").value = "true";
}

const getCookie = (name) => {
    const value = " " + document.cookie;
    const parts = value.split(" " + name + "=");
    const cookieValue = parts.length < 2 ? undefined : parts.pop().split(";").shift();
    return cookieValue;
};

const setCookie = (name, value, days = 365) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
};

const initCookieBanner = () => {
    const cookiesBanner = document.querySelector(".cookies-eu-banner");
    const cookiesBannerButton = cookiesBanner.querySelector("button");
    const cookieName = "cookiesBanner";
    const cookieValue = getCookie(cookieName);

    if (cookieValue == "closed") {
        cookiesBanner.classList.add('d-none');
    } else {
        cookiesBanner.classList.remove('d-none');
        cookiesBannerButton.addEventListener("click", () => {
            setCookie(cookieName, "closed");
            cookiesBanner.remove();
        });
    }
};

const initTomSelect = () => {
    // Inizializzo l'istanza della tendina con ricerca
    const prodottoSelect1    = document.getElementById('Input1_Prodotto1');
    const prodottoSelect2    = document.getElementById('Input1_Prodotto2');

    if (!prodottoSelect1 || !prodottoSelect2)
        return;

    const prodottoTS1 = new TomSelect(prodottoSelect1, {
        maxItems: 1,
        create: false,
        allowEmptyOption: false,
        placeholder: 'Cerca un prodotto...',
        plugins: ['clear_button'],
        render: {
            no_results: function(data,escape){
                return '<div class="no-results">Nessun risultato trovato</div>';
            }
        }
    });

    const prodottoTS2 = new TomSelect(prodottoSelect2, {
        maxItems: 1,
        create: false,
        allowEmptyOption: false,
        placeholder: 'Cerca un prodotto...',
        plugins: ['clear_button'],
        render: {
            no_results: function(data,escape){
                return '<div class="no-results">Nessun risultato trovato</div>';
            }
        }
    });
};

/* Ready callback function */
ready(() => {
    initWebpackVersion();
    initCleave();
    initShowPassword();
    initFormValidation();
    closeMenuByNav();
    initTomSelect();
    initReceiptUpload();
    initCookieBanner();
});

window.goToAnchor = goToAnchor;
window.showLoading = showLoading;
window.hideLoading = hideLoading;
window.goBack = goBack;
